import axios from 'axios';

import { getApiBaseUrl } from '../../utils/environment';

const DEFAULT_API_TIMEOUT = 3000;

export const axiosClient = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: DEFAULT_API_TIMEOUT,
  transitional: {
    clarifyTimeoutError: true,
  },
});
